<template>
    <div :class="containerClass">
        <slot :data="windowData"></slot>
    </div>
</template>

<script>
export default {
    props: {
        window: {
            type: String,
            required: true
        },
        data: {
            type: String,
            default: ''
        },
        noValueText: {
            type: String,
            text: ''
        },
        noValueClass: {
            type: String,
            class: null
        }
    },
    data() {
        return {
            windowData: this.data
        }
    },
    computed: {
        containerClass() {
            return this.windowData.length ? '' : this.noValueClass;
        }
    },
    created() {
        this.$root.$on('window.opened', window => {
            if(window.id == this.window) {
                window.data = this.windowData;
            }
        });

        this.$root.$on('window.closed', window => {
            if(window.id == this.window) {
                this.windowData = window.data;
            }
        });
    },
    mounted() {
        if(!this.data) {
            this.windowData = this.$el.innerHTML;
            this.$el.innerHTML = this.windowData.length ? this.windowData : this.noValueText;
        }
    },
    updated() {
        this.$el.innerHTML = this.windowData.length ? this.windowData : this.noValueText;
    }
}
</script>